<template>
    <button
        type="button"
        :class="classList"
        style="height: 38px; min-width: 38px;"
        :disabled="disabled"
        v-on="listeners"
    >
        <slot>
            <svg
                class="afu-h-5 afu-w-5"
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path
                    fill-rule="evenodd"
                    :d="arrowDirectionSvg"
                    clip-rule="evenodd"
                />
            </svg>
        </slot>
    </button>
</template>

<script>
    export default {
        name: 'C1PaginatorArrow',

        props: {
            next: {
                type: Boolean,
                default: false,
            },

            disabled: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
            };
        },

        computed: {
            classList() {
                return [
                    'afu-mx-1 afu-inline-flex afu-items-center afu-justify-center afu-text-primary-400 afu-border afu-border-solid afu-border-gray-300 afu-bg-white afu-rounded-lg afu-text-xl focus:afu-outline-none afu-leading-5 afu-transition afu-ease-in-out afu-duration-150',
                    this.getBgColorClass,
                ];
            },

            arrowDirectionSvg() {
                return this.next ? 'M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z' : 'M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z';
            },

            listeners() {
                return this.$listeners;
            },
        },
    };
</script>
